import ProductsError from './ProductsError.js'

export default class GetVisibilityProductsError extends ProductsError {}
